// Marketing-Site (www.tennis-matches.de) – lokale Fallback-Texte
export default {
  "marketing.brand": "Tennis-Matches",
  "marketing.product.trainingsdesk": "TrainingsDesk",
  "marketing.nav.features": "Funktionen",
  "marketing.nav.workflow": "Ablauf",
  "marketing.nav.roles": "Rollen",
  "marketing.nav.pricing": "Preise",
  "marketing.nav.cta": "App öffnen",
  "marketing.nav.aria": "Hauptnavigation",
  "marketing.skipToContent": "Zum Inhalt springen",

  "marketing.seo.title":
    "TrainingsDesk – Trainingsplanung & Abrechnung für Tennisvereine | Tennis-Matches",
  "marketing.seo.description":
    "TrainingsDesk organisiert Vereinstraining digital: planen, Anwesenheit bestätigen, Elternportal, Rechnungen, Trainer-Auszahlungen und Finanzen – in einer App.",
  "marketing.seo.keywords":
    "TrainingsDesk, Tennis Trainingsverwaltung, Trainer Abrechnung, Vereinstraining Software, Tennisverein App, Elternportal Tennis, Trainingsplanung",
  "marketing.seo.ogTitle":
    "TrainingsDesk – das Betriebssystem für Vereinstraining",
  "marketing.seo.ogDescription":
    "Von der Planung bis zur Zahlung: TrainingsDesk für Trainer, Vereine und Eltern.",

  "marketing.hero.brand": "Tennis-Matches",
  "marketing.hero.product": "TrainingsDesk",
  "marketing.hero.headline": "Vereinstraining. Endlich digital im Griff.",
  "marketing.hero.lead":
    "Planen, bestätigen, abrechnen und mit Eltern abstimmen – ein Modul für Trainer, Koordinatoren und Familien.",
  "marketing.hero.ctaPrimary": "Kostenlos starten",
  "marketing.hero.ctaSecondary": "Funktionen ansehen",
  "marketing.hero.trust":
    "Für Vereine und unabhängige Trainer · 30 Tage testen",

  "marketing.proof.aria": "Kurzüberblick",
  "marketing.proof.plan": "Kalender & Serien",
  "marketing.proof.confirm": "Anwesenheit & Stunden",
  "marketing.proof.bill": "Rechnungen & PayPal",
  "marketing.proof.parent": "Elternportal",

  "marketing.workflow.eyebrow": "So läuft’s",
  "marketing.workflow.title": "Vier Schritte. Ein roter Faden.",
  "marketing.workflow.lead":
    "TrainingsDesk bildet den echten Vereinsalltag ab – ohne Excel-Wildwuchs und WhatsApp-Chaos.",
  "marketing.workflow.step1.title": "Planen",
  "marketing.workflow.step1.text":
    "Einzeltermine oder Serien anlegen, Ferien berücksichtigen, Trainer und Orte zuweisen.",
  "marketing.workflow.step2.title": "Bestätigen",
  "marketing.workflow.step2.text":
    "Zu-/Absagen, Anwesenheit erfassen, Stunden bestätigen – Grundlage für jede Abrechnung.",
  "marketing.workflow.step3.title": "Abrechnen",
  "marketing.workflow.step3.text":
    "Monatsabschluss, Entwürfe, Versand per E-Mail, Stornos und Korrekturen nachvollziehbar.",
  "marketing.workflow.step4.title": "Verbuchen",
  "marketing.workflow.step4.text":
    "Zahlungen zuordnen, Ausgaben erfassen, Bilanz und Analytics im Blick behalten.",

  "marketing.features.eyebrow": "Funktionen",
  "marketing.features.title": "Alles für den Trainingsbetrieb",
  "marketing.features.lead":
    "Ein Arbeitsplatz für den Tag, die Woche und den Monatsabschluss – mobil und am Desktop.",

  "marketing.feature.hub.title": "Tagesübersicht",
  "marketing.feature.hub.text":
    "Cockpit mit heutigen Trainings, priorisierter Aufgaben-Inbox, KPIs und Schnellaktionen.",
  "marketing.feature.planning.title": "Trainingstermine",
  "marketing.feature.planning.text":
    "Kalender und Liste, Serien, Verschieben, Nachholtermine, ICS-Export und Drag-and-drop.",
  "marketing.feature.attendance.title": "Anwesenheit",
  "marketing.feature.attendance.text":
    "Zu-/Absagen, Anwesenheit und Stundenbestätigung – mit Sperre nach Abrechnung.",
  "marketing.feature.parent.title": "Elternportal",
  "marketing.feature.parent.text":
    "Termine bestätigen, Rechnungen einsehen, online zahlen und Extra-Stunden buchen.",
  "marketing.feature.booking.title": "Buchungsanfragen",
  "marketing.feature.booking.text":
    "Elternanfragen annehmen, ablehnen oder mit Gegenvorschlag beantworten.",
  "marketing.feature.billing.title": "Familien-Abrechnung",
  "marketing.feature.billing.text":
    "Offene Posten, Entwürfe, Versand, Archiv, Storno-Ketten und öffentliche Zahllinks.",
  "marketing.feature.payouts.title": "Trainer-Auszahlungen",
  "marketing.feature.payouts.text":
    "Honorare aus bestätigten Stunden, Auszahlungs-Dashboard und Settlement-Sperren.",
  "marketing.feature.finance.title": "Finanzen",
  "marketing.feature.finance.text":
    "Zahlungen, Belege mit KI-Extraktion, Ausgabenkategorien und Jahresbilanz.",
  "marketing.feature.analytics.title": "Auswertung",
  "marketing.feature.analytics.text":
    "Umsatz, Stunden, Absagen, Heatmaps und Rankings – filterbar nach Zeitraum und Trainer.",
  "marketing.feature.contacts.title": "Kontakte",
  "marketing.feature.contacts.text":
    "Personenstamm, Eltern-Kind-Beziehungen, Rechnungsempfänger und App-Einladungen.",
  "marketing.feature.admin.title": "Verwaltung",
  "marketing.feature.admin.text":
    "Trainer, Preismodelle, Ferien, Rechnungslayout, Kalenderzeiten und Rollenrechte.",
  "marketing.feature.integrations.title": "Integrationen",
  "marketing.feature.integrations.text":
    "WhatsApp-Erinnerungen, Tennify-Platzbuchung und E-Mail-Versand für Rechnungen.",
  "marketing.feature.mobile.title": "Mobil & nativ",
  "marketing.feature.mobile.text":
    "Web und native iOS-App: Hub, Termine, Rückstand und Session-Bestätigung unterwegs.",
  "marketing.feature.solo.title": "Solo-Trainer",
  "marketing.feature.solo.text":
    "Eigenes Toolkit ohne Vereinszwang: Profil, Kontakte, Orte, Abrechnung und Bilanz.",

  "marketing.roles.eyebrow": "Rollen",
  "marketing.roles.title": "Jede Rolle sieht, was sie braucht",
  "marketing.roles.lead":
    "Koordinatoren steuern den Betrieb, Trainer arbeiten im Alltag, Eltern bleiben im Loop.",
  "marketing.roles.coord.title": "Verein & Koordination",
  "marketing.roles.coord.text":
    "Stammdaten, Rechte, Monatsabschluss, Analytics und Vereinsabo an einem Ort.",
  "marketing.roles.trainer.title": "Trainer",
  "marketing.roles.trainer.text":
    "Kalender, Anwesenheit, Bestätigungen und – je nach Plan – Abrechnung und Finanzen.",
  "marketing.roles.parent.title": "Eltern & Spieler",
  "marketing.roles.parent.text":
    "Portal für Termine, Absagen, Rechnungen, Online-Zahlung und Extra-Buchungen.",
  "marketing.roles.solo.title": "Unabhängige Trainer",
  "marketing.roles.solo.text":
    "Volles Solo-Toolkit ohne Vereinsmandant – vom Kontakt bis zur Bilanz.",

  "marketing.pricing.eyebrow": "Vereinsabo",
  "marketing.pricing.title": "Klar gestaffelt",
  "marketing.pricing.lead":
    "30 Tage testen. Danach Starter, Pro oder Gold – passend zur Vereinsgröße.",
  "marketing.pricing.trial": "30 Tage Testphase",
  "marketing.pricing.perMonth": "/ Monat",
  "marketing.pricing.cta": "Jetzt testen",
  "marketing.pricing.starter.name": "Starter",
  "marketing.pricing.starter.price": "4,99 €",
  "marketing.pricing.starter.f1": "Trainingsplanung",
  "marketing.pricing.starter.f2": "Anwesenheit & Bestätigung",
  "marketing.pricing.starter.f3": "Kontakte & Elternportal",
  "marketing.pricing.pro.name": "Pro",
  "marketing.pricing.pro.price": "9,99 €",
  "marketing.pricing.pro.badge": "Beliebt",
  "marketing.pricing.pro.f1": "Alles aus Starter",
  "marketing.pricing.pro.f2": "Abrechnung & Finanzen",
  "marketing.pricing.pro.f3": "Analytics & Auswertungen",
  "marketing.pricing.gold.name": "Gold",
  "marketing.pricing.gold.price": "17,99 €",
  "marketing.pricing.gold.f1": "Alles aus Pro",
  "marketing.pricing.gold.f2": "Club-Apps im Ökosystem",
  "marketing.pricing.gold.f3": "Für Vereine mit mehr Modulen",

  "marketing.cta.title": "Bereit für ruhigere Trainingswochen?",
  "marketing.cta.lead":
    "Starte mit TrainingsDesk – Planung heute, Abrechnung wenn du soweit bist.",
  "marketing.cta.button": "TrainingsDesk öffnen",

  "marketing.footer.product": "Produkt",
  "marketing.footer.features": "Funktionen",
  "marketing.footer.pricing": "Preise",
  "marketing.footer.app": "Zur App",
  "marketing.footer.legal": "Rechtliches",
  "marketing.footer.imprint": "Impressum",
  "marketing.footer.privacy": "Datenschutz",
  "marketing.footer.tagline":
    "Tennis-Matches – digitale Tools für Vereine, Trainer und Spieler.",
  "marketing.footer.copyright": "© {year} Tennis-Matches.de",
};
